module.exports = __webpack_public_path__ + "static/media/2.58c2b043.png";